/* eslint-disable prettier/prettier */
import styled, { css } from 'styled-components';

export const AgeText = styled.span`
  ${({ theme }) => theme.kallisto.mixins.font('BodySmall')};
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
`;

export const SuccessText = styled.span`
  ${({ theme }) => theme.kallisto.mixins.font('BodySmall')};
  color: ${({ theme }) => theme.kallisto.color.text.static.textSuccess};
  
`;

export const PriceBottomContainer = styled.div<{ $isOverlay: boolean; $isDoublePricing?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
  text-align: right;
  ${({ theme }) => theme.kallisto.mixins.font('BodySmall')};

  ${({ $isDoublePricing }) =>
    $isDoublePricing &&
    css`
      gap: 4px;
    `};

  ${({ $isOverlay }) =>
    $isOverlay &&
    css`
      text-align: left;
    `};

  @media (max-width: 767px) {
    align-items: flex-start;
    text-align: left;
  }
`;